export * from '@taqueria/protocol/out/types/NonEmptyString';
